import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--general-spacer-04, 24px);
  width: 100%;
`;

export const CategoryBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--general-spacer-01, 4px);
  padding-bottom: var(--general-spacer-03, 16px);
  width: 100%;
`;

export const CategoryHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--general-spacer-01, 4px);
  padding-bottom: var(--general-spacer-01, 4px);
`;

export const CategoryDescription = styled.p`
  margin: 0;
  padding-bottom: var(--general-spacer-01, 4px);
`;

export const ChipsWrapper = styled.div`
  margin-top: var(--general-spacer-02, 8px);
`;

export const CarouselWrapper = styled.div`
  // padding: var(--general-spacer-02, 8px) 0;
`;
